import { Component, OnInit } from '@angular/core';
import { DwComponentSectionConfigPreference, DwMdItem, DwMdSectionConfigBaseComponent2 } from '@devwareapps/devware-cap';
import { GoogleMapConfig } from '../../models/google-map-config.model';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-google-map-config',
  templateUrl: './google-map-config.component.html',
  styleUrls: ['./google-map-config.component.scss']
})
export class GoogleMapConfigComponent
  extends  DwMdSectionConfigBaseComponent2<DwComponentSectionConfigPreference<GoogleMapConfig>> {
 
  configFormGroup: FormGroup;
  itemMetaData: DwMdItem;

  
  setupForm() {
    // Add config fields to the form

    this.configFormGroup = new FormGroup({
      latitudeAttr: new FormControl(),
      longitudeAttr: new FormControl(),
      color: new FormControl(),
      displayTemplate: new FormControl(),
    });

    this.formGroup.addControl('config', this.configFormGroup);
  }


  setupAttributeList() {
    this.getItemMetaData(this.itemName)
      .subscribe(itemMetaData => {
        this.itemMetaData = itemMetaData;
      });
  }

}